import ja from 'locale/ja.generated.json';
import {addLocale} from 'ttag';
import {TTagTranslations} from 'ttag/dist/config';

export const initializeTtag = () => {
    const translations: Record<string, TTagTranslations> = {
        ja,
    };
    Object.entries(translations).forEach(([locale, data]) => {
        addLocale(locale, data);
    });
};
